module.exports = __webpack_public_path__ + "img/thumb_26.6b3854fd.jpg";